/**
 * Converts image to data url
 * @param image - image to convert
 */
function ToDataURL(image: HTMLImageElement): string
{
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0);

    return canvas.toDataURL();
}

export default ToDataURL;